import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import * as angular from "angular";
import * as moment from "moment";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface DefectService {
  getDefectEquipment: () => angular.IPromise<apsViewModels.DefectEquipmentSelection[]>;
  addDefect: (defect: apsCommands.AddDefect) => angular.IPromise<any>;
  addMoldLoss: (defect: apsCommands.AddMoldLoss) => angular.IPromise<any>;
  getMoldLossStatus: (shopId: string, defectId: string) => angular.IPromise<apsViewModels.MoldLossResponse>;
  addDefectComment: (defect: apsCommands.AddDefectComment) => angular.IPromise<any>;
  updateDefectMoldReject: (defectMoldReject: apsCommands.UpdateDefectMoldReject) => angular.IPromise<any>;
  updateDefectEquipFailure: (defectEquipFail: apsCommands.UpdateDefectEquipFailure) => angular.IPromise<any>;
  deleteDefect: (defectId: string, reason: string) => angular.IPromise<any>;
  getDefect: (defectId: string) => angular.IPromise<apsViewModels.DefectDetails>;
  getDefectLossTypes: () => angular.IPromise<apsViewModels.DefectLossType>;
  getCriticalDefectReportDetails: (
    defectId: string,
    shopId: string,
    roleId: string,
    scheduledOn: Date) => angular.IPromise<apsViewModels.DefectCriticalReportDetails>;
  addHeldPallets: (command: apsCommands.AddHeldPallets) => angular.IPromise<any>;
  deleteHeldPallets: (command: apsCommands.DeleteHeldPallets) => angular.IPromise<any>;
  getMachineDefectQuestion: (defectId: string, isMnr?: boolean) => angular.IPromise<any>;
  getMoldRejectStatus: (defectId: string) => angular.IPromise<boolean>;
  getActiveMnrs(ShopId: string, processDate: moment.Moment): angular.IPromise<apsViewModels.ActiveMnr[]>;
}

export default angular.module('aps.services.defects', [HttpServiceName])
  .service('defectService', function (httpService: HttpService): DefectService {
    var getDefectEquipment = () => {
      return httpService.get<apsViewModels.DefectEquipmentSelection[]>(Endpoints.DEFECT_EQUIPMENT);
    };

    var addDefect = function (defect) {
      return httpService.post(Endpoints.DEFECT, defect);
    };

    var addMoldLoss = function (moldLoss) {
      if (moldLoss && (moldLoss.isRejectInvalidMolds != undefined || moldLoss.isRejectMold != undefined)) {
        return httpService.post(Endpoints.DEFECT_MOLD_LOSS, moldLoss);
      }
    };

    var getMoldLossStatus = function (shopId, defectId) {
      return httpService.get<apsViewModels.MoldLossResponse>(Endpoints.DEFECT_MOLD_LOSS_STATUS, { shopId: shopId, defectId: defectId });
    };

    var getMoldRejectStatus = function (defectId) {
      return httpService.get<boolean>(Endpoints.DEFECT_MOLD_REJECT_STATUS+ "/"+ defectId );
    };

    var addDefectComment = function (defectComment) {
      return httpService.post(Endpoints.DEFECT_COMMENT, defectComment);
    };

    var addHeldPallets = function (command) {
      return httpService.post(Endpoints.DEFECT_HELD_PALLETS, command);
    };
    var deleteHeldPallets = function (command) {
      return httpService.post(Endpoints.DEFECT_HELD_PALLETS_DELETE, command);
    };

    var updateDefectMoldReject = function (defectMoldReject: apsCommands.UpdateDefectMoldReject) {
      return httpService.post(Endpoints.DEFECT_MOLD_REJECT, defectMoldReject);
    };
    var updateDefectEquipFailure = function (defectEquipFail: apsCommands.UpdateDefectEquipFailure) {
      return httpService.post(Endpoints.DEFECT_EQUIP_FAIL, defectEquipFail);
    };
    var deleteDefect = function (defectId, reason) {
      return httpService.delete(Endpoints.DEFECT + '/' + defectId, { reason: reason });
    };
    var getDefect = function (defectId) {
      return httpService.get<apsViewModels.DefectDetails>(Endpoints.DEFECT_DETAILS + '/' + defectId);
    };
    var getDefectLossTypes = function () {
      return httpService.get<apsViewModels.DefectLossType>(Endpoints.DEFECT_LOSS_TYPES);
    };
    var getCriticalReport = (defectId: string, shopId: string, roleId: string, scheduledOn: Date) => {
      return httpService.get<apsViewModels.DefectCriticalReportDetails>(
        Endpoints.DEFECT_CRITICAL_REPORT + '/' + defectId,
        { shopId: shopId, roleId: roleId, scheduledOn: scheduledOn }
      );
    };

    var getMachineDefectQuestion = (defectId, isMnr) => {
      return httpService.get(Endpoints.MACHINE_DEFECT_QUESTION + '/' + defectId,{isMnr:isMnr});
    };
    var getActiveMnrs = (shopId, date) => {
      let processDate = date ? moment(date).format("MM/DD/YYYY") : moment().format('MM/DD/YYYY');
      return httpService.get<apsViewModels.ActiveMnr[]>(Endpoints.ACTIVE_MNRS, { shopId: shopId, processDate: processDate });
    }

    return {
      getDefectEquipment: getDefectEquipment,
      addDefect: addDefect,
      addMoldLoss: addMoldLoss,
      addDefectComment: addDefectComment,
      addHeldPallets: addHeldPallets,
      deleteHeldPallets: deleteHeldPallets,
      updateDefectMoldReject: updateDefectMoldReject,
      deleteDefect: deleteDefect,
      getDefect: getDefect,
      getDefectLossTypes: getDefectLossTypes,
      updateDefectEquipFailure: updateDefectEquipFailure,
      getCriticalDefectReportDetails: getCriticalReport,
      getMoldLossStatus: getMoldLossStatus,
      getMachineDefectQuestion: getMachineDefectQuestion,
      getMoldRejectStatus: getMoldRejectStatus,
      getActiveMnrs: getActiveMnrs
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/defects/defect.service.ts